// ----------------------------------------------------------------------
// <copyright file="Izenda.SizeSetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 *  Size Setting component
 */
!(function() {
  var React = require('react');
  var m = require('mobx-react');
  var classnames = require('classnames');
  var NumericInput = require('share/components/controls/Izenda.NumericInput');
  var localizer = require('share/localization/Izenda.Localizer');
  const { cloneDeep, get } = require('lodash/fp');
  var SizeSetting = React.createClass({
    getInitialState: function() {
      var originalValue = cloneDeep(this.props.value);
      return {
        value: this.props.value,
        originalValue: originalValue
      };
    },

    propTypes: {
      value: React.PropTypes.number,
      onChange: React.PropTypes.func
    },

    getDefaultProps: function() {
      return {
        value: 0
      };
    },

    onValueChange: function(e) {
      var props = this.props;
      var value = e;
      this.setState({ value: value });
      props.onChange && props.onChange({ value: value });
    },

    /**
     * Handle on blur.
     */
    onBlur: function(e) {
      var currentValue = this.state.value;
      var originalValue = this.state.originalValue;
      if (currentValue < 0 || currentValue > Math.pow(2, 32)) {
        this.setState({ value: originalValue });
      }
    },

    componentWillReceiveProps: function(nextProps) {
      this.setState({ value: get(this.props.propertyKey, nextProps.loadValue) });
    },

    shouldComponentUpdate: function(nextProps, nextState) {
      return this.state.value !== nextState.value;
    },

    componentWillUpdate: function() {
      this.setState({ value: get(this.props.propertyKey, this.props.loadValue) });
    },

    render: function() {
      var className = classnames('height-format input-group', this.props.className);
      return (
        <div className={className}>
          <NumericInput
            value={get(this.props.propertyKey, this.props.loadValue)}
            onChange={this.onValueChange}
            onBlur={this.onBlur}
          />
          <span className="height-unit input-group-addon">{localizer.getText('UI_CONSTANT_PIXEL')}</span>
        </div>
      );
    }
  });

  module.exports = m.observer(SizeSetting);
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.SizeSetting.jsx